import React from "react"
import PropTypes from "prop-types"
import HelpWidgetChartInteractiveMolecule from "views/molecules/interactive/HelpWidgetChartInteractiveMolecule"
import {
  TextChart,
  TextChartMinor,
} from "components/widgets/ScorePage/widgets/TextCharts"
import ChartBadge from "views/atoms/badges/ChartBadge"
import { useTranslation } from "react-i18next"
import ChartWithBadgeWrapperMolecule from "views/molecules/charts/ChartWithBadgeWrapperMolecule"
import { round } from "services/units/round"

const TRANSLATION_PREFIX =
  "analyze:it_domain.cloud.kpis.service_in_carbon_country"

const TextAnalysisCloudServiceInCarbonCountry = ({ value, trendBadge }) => {
  const { t } = useTranslation()
  const highCarbonPercentage = Number(value) || 0
  const lowCarbonPercentage = Math.max(0, 100 - highCarbonPercentage)
  const reversedTrendBadge = trendBadge
    ? {
        ...trendBadge,
        symbol:
          trendBadge.symbol === "up"
            ? "down"
            : trendBadge.symbol === "down"
              ? "up"
              : trendBadge.symbol,
      }
    : null

  const badge = (
    <ChartBadge value={lowCarbonPercentage} lowerLimit={30} upperLimit={60} />
  )

  const content = {
    kpi_text: t(`${TRANSLATION_PREFIX}.sub_title`),
    kpi: `${round(lowCarbonPercentage, 0)}% ${t(`${TRANSLATION_PREFIX}.title`)}`,
    reference: badge,
  }

  const content_for_display = (
    <TextChartMinor content={content} noSubtextHover={true} />
  )

  const chartContent = <TextChart content={content_for_display} />

  return (
    <HelpWidgetChartInteractiveMolecule text={t(`${TRANSLATION_PREFIX}.help`)}>
      <ChartWithBadgeWrapperMolecule trendBadge={reversedTrendBadge} color="auto">
        {chartContent}
      </ChartWithBadgeWrapperMolecule>
    </HelpWidgetChartInteractiveMolecule>
  )
}

TextAnalysisCloudServiceInCarbonCountry.propTypes = {
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  trendBadge: PropTypes.object,
}

TextAnalysisCloudServiceInCarbonCountry.defaultProps = {
  trendBadge: null,
}

export default TextAnalysisCloudServiceInCarbonCountry
